
import i18n from '@/i18n';
import { Assessment, EvaluationSheet } from '@/models/assessment.model';
import { Icon, Modal } from '@descomplica/vue-components';
import dayjs from 'dayjs';
import Vue, { PropType } from 'vue';
import { TranslateResult } from 'vue-i18n';
import PostGradAssessmentResultModalSkeleton from '@/components/skeletons/PostGradAssessmentResultModalSkeleton.vue';

export default Vue.extend({
  components: {
    Icon,
    Modal,
    PostGradAssessmentResultModalSkeleton,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    assessment: {
      type: Object as PropType<Assessment>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: this.active,
      showLoading: true,
    };
  },
  computed: {
    borderRadius(): number {
      return this.getBorderRadius(window.innerWidth);
    },
    courseName(): string {
      return this.$store.getters.currentCourse.name;
    },
    userName(): string {
      return this.$store.getters.currentAlumniProfile.displayName;
    },
    grade(): number {
      return this.assessment.assessmentResultsByUser[0].grade;
    },
    gradeFormatted(): string {
      return (Math.trunc(this.grade * 10) / 10).toFixed(1);
    },
    gradingDate(): string {
      return dayjs(this.assessment.assessmentResultsByUser[0].gradingDate).format('DD/MM/YYYY');
    },
    evaluationSheet(): EvaluationSheet {
      return this.assessment.assessmentResultsByUser[0].evaluationSheet;
    },
    reviewerFeedback(): string {
      return this.assessment.assessmentResultsByUser[0]?.lastReply?.feedbackText || '';
    },
    feedbackMessage(): TranslateResult {
      return this.reviewerFeedback
        ? this.reviewerFeedback
        : i18n.t('yourAssessments.result.reviewerFeedback.noFeedback');
    },
    plagiarismFound(): boolean {
      return this.assessment.assessmentResultsByUser[0].evaluationSheet.isPlagiarism;
    },
    plagiarismIconClass(): string {
      return this.plagiarismFound ? '--failure' : '--success';
    },
    plagiarismIconName(): string {
      return this.plagiarismFound ? 'exclamation' : 'check';
    },
    plagiarismText(): TranslateResult {
      return this.plagiarismFound
        ? i18n.t('yourAssessments.result.plagiarism.found')
        : i18n.t('yourAssessments.result.plagiarism.notFound');
    },
    resultMessage(): TranslateResult {
      if (this.assessment.assessmentResultsByUser === undefined) return '';

      const { passingGradePercentage } = this.assessment;

      const diff = this.grade - passingGradePercentage * 10;

      if (diff >= 1) return i18n.t('yourAssessments.result.titles.aboveAverage');
      if (diff >= 0) return i18n.t('yourAssessments.result.titles.average');
      return i18n.t('yourAssessments.result.titles.belowAverage');
    },
  },
  watch: {
    active(value) {
      this.isActive = value;
    },
    loading: {
      immediate: true,
      handler(value) {
        this.showLoading = value;
      },
    },
  },
  methods: {
    getBorderRadius(width: number): number {
      if (width > 495) return 24;
      return 0;
    },
    updateActive(active: boolean) {
      this.$emit('update:active', active);
    },
    onCloseClick() {
      this.updateActive(false);
    },
  },
});
